export default __webpack_public_path__ + "b22351bea254b10bef1c26d3cc3ef397.png";